<template>
  <div class="full-width">
    <top-nav :isWhite="false" :hasLogo="true" :lang="$route.params.lang"></top-nav>
    <main class="flex flex-column">
      <articles-list :lang="$route.params.lang" :standalone="true"></articles-list>
    </main>
    <footer-bar :lang="$route.params.lang"></footer-bar>
  </div>
</template>

<script>
import ArticlesList from '@/components/ArticlesList'

export default {
  components: {
    'articles-list': ArticlesList
  },

  watch: {
    '$route' (to, from) {
      if (from.params.lang !== to.params.lang || from.params.slug !== to.params.slug) {
        this.init()
      }
    }
  },

  created () {
    this.init()
  },

  data () {
    return {
      titles: {
        ru: 'Интервью экспертов и другие материалы',
        en: 'Expert interviews and other materials'
      }
    }
  },

  methods: {
    init: function () {
      this.lang = this.lang || this.$route.params.lang || this.defineDefaultLang()
      this.updateMeta(this.lang)
    },

    updateMeta: function () {
      document.title = this.titles[this.lang]
      let oglist = [
        {name: 'og:title', content: this.titles[this.lang]},
        {name: 'og:type', content: 'website'},
        {name: 'og:image', content: window.location.host + '/static/covers/public_opinion-3@2x.jpg'},
        {name: 'og:url', content: window.location}
      ]
      for (let og of oglist) {
        let m = document.createElement('meta')
        m.name = og.name
        m.content = og.content
        document.querySelector('head').appendChild(m)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ArticlesHome.vue?e22e01f2